<template>
  <div>
    <el-dialog
      :visible="visible"
      @close="$emit('update:visible', false)"
      @closed="days = 0,codes = null"
    >
      <div
        slot="title"
        class="Diatitle"
      >
        <span>{{title}}</span>
      </div>
      <el-input
        type="textarea"
        :rows="4"
        placeholder="请输入内容"
        v-model="codes"
      >
      </el-input>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="$emit('update:visible', false)"
          size="small"
        >取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="$emit('autoRecordClick',codes)"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      codes: ""
    };
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
  width: 500px !important;
}
</style>